import React from 'react'
import parse, { domToReact, Element, type DOMNode, type HTMLReactParserOptions } from 'html-react-parser'
import { AppLink } from 'components/Utility/AppLink/AppLink'

const parserOptions: HTMLReactParserOptions = {
  replace: (node) => {
    if (node instanceof Element && node.name === 'a') {
      const { href, ...props } = node.attribs
      delete props.style
      delete props.class
      delete props.target
      return <AppLink path={href} {...props}>{domToReact(node.children as DOMNode[], parserOptions)}</AppLink>
    }
    return undefined
  },
}

/** Renders CMS HTML; links go through AppLink so internal ones use the router */
export const parseHtml = (html: string) => parse(html.replaceAll('\n', ''), parserOptions)
